import { createContext } from "react";

export const BatchDetailsContext = createContext();
